import { InputText } from "primereact/inputtext";
import { JVInput } from "../../shared/JVInput";
import { useState } from "react";
import { Button } from "primereact/button";

interface IProps {
    list: { id: any, description: string, hours: number, rate: number, amount: number }[];
    setList: React.Dispatch<React.SetStateAction<{ id: any, description: string, hours: number, rate: number, amount: number }[]>>;
    id: any;
    description: string;
    hours: number;
    rate: number;
    amount: number;
    toast: any;
}

export const SVInvoiceAdditionalExpenses = (props: IProps) => {
    return (
        <div className="p-fluid formgrid grid w-full" style={{ border: "1px solid rgb(210, 208, 208)", marginLeft: "0px", paddingTop: "5px" }}>
            <div className={'field col-12 md:col-3'}>
                <label>Enter Description<span style={{ color: 'red' }}>*</span></label>
                <InputText value={props.description} placeholder={"Enter Description"} onChange={(event: any) => {
                    props.setList(props.list.map((el: { id: any, description: string, hours: number, rate: number, amount: number }, i: number) => (el.id === props.id ? { ...el, description: event.target.value } : el)));
                }} type={"text"} />
            </div>
            <div className={'field col-12 md:col-3'}>
                <label>Enter Working Hours<span style={{ color: 'red' }}>*</span></label>
                <InputText value={props.hours} placeholder={"Enter Working Hours"} onChange={(event: any) => {
                    props.setList(props.list.map((el: { id: any, description: string, hours: number, rate: number, amount: number }, i: number) => (el.id === props.id ? { ...el, hours: event.target.value, amount: ((event.target.value) * el.rate) } : el)));
                }} type={"number"} />
            </div>
            <div className={'field col-12 md:col-3'}>
                <label>Rate</label>
                <InputText value={props.rate} placeholder={"Enter Working Hours"} onChange={(event: any) => {
                    props.setList(props.list.map((el: { id: any, description: string, hours: number, rate: number, amount: number }, i: number) => (el.id === props.id ? { ...el, rate: event.target.value, amount: ((event.target.value) * el.hours) } : el)));
                }} type={"number"} />
            </div>
            <div className={'field col-12 md:col-3'}>
                <span className="flex"><label>Invoice Amount</label> <Button
                    type="button"
                    icon="pi pi-trash"
                    tooltip="Delete This Row"
                    style={{ height: "24px", marginLeft: "38%" }}
                    className="p-button-rounded p-button-text p-button-danger"
                    onClick={() => {
                        const newData: { id: any, description: string, hours: number, rate: number, amount: number }[] = props.list.filter((_, i) => _.id !== props.id);
                        props.setList((prev) => (prev = newData));
                    }}
                /></span>
                <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{props.amount}</p>
            </div>
        </div>
    );
}